import { AutoQaError } from '../../../team-apis/otterdam/auto-qa-response';

export interface SubmissionErrors {
  // AutoQA deny submission and requires user to fix the errors
  blockingErrors: AutoQaError[];

  // Submission failed, but other messages might have been shown just
  // release ability to work and dont execute further actions
  benignErrors: string[];

  // Submission was successful, but there were errors
  // Halt the user ability to work on the task and ask for a reload
  serverErrors: string[];
}

export function isSubmissionErrors<T>(
  errors: T | SubmissionErrors,
): errors is SubmissionErrors {
  const { blockingErrors, benignErrors, serverErrors } =
    errors as SubmissionErrors;
  return (
    Array.isArray(blockingErrors) &&
    Array.isArray(benignErrors) &&
    Array.isArray(serverErrors)
  );
}

export function hasSubmissionErrors(errors: SubmissionErrors): boolean {
  return (
    errors.blockingErrors.length > 0 ||
    errors.benignErrors.length > 0 ||
    errors.serverErrors.length > 0
  );
}

export function createSubmissionsErrors(
  submissionErrors: Partial<SubmissionErrors> = {},
): SubmissionErrors {
  return {
    blockingErrors: [],
    benignErrors: [],
    serverErrors: [],
    ...submissionErrors,
  };
}
